"use client";
import {
    Card,
    CardHeader,
    CardBody, Link
} from "@heroui/react";
import { ButtonOverride as Button } from "@/components/Buttons/ButtonOverride";
import { notFoundSettings } from "@/constants/project-specific/theme/notfound";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col flex-wrap align-middle w-full content-center justify-center items-center h-dvh -mt-16">
      <div className="">
        <Card className="max-w-[600px] content-center justify-center drop-shadow-sm hover:drop-shadow-lg bg-gradient-to-r from-gray-900 via-gray-800 to-gray-950">
          <CardHeader className="w-full content-center justify-center text-2xl">
            Failed to Fetch Token Price Data!
          </CardHeader>
          <CardBody className="p-3">
            <div className="flex flex-col flex-wrap justify-center align-middle items-center content-center">
              <div>
                <img
                  src={notFoundSettings.imgUrl}
                  alt="Not Found"
                  className="w-[300px] h-[300px] mb-4"
                />
              </div>
              <span className="text-center">
                Please wait a few seconds and try again. If the issue persists,
                please notify the team!
              </span>
              <Button
                as={Link}
                color="danger"
                variant="shadow"
                size="lg"
                href="/"
                className="max-w-lg place-self-center m-3"
              >
                Go Back
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
